import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.188 13.5c.765 0 1.476-.41 1.886-1.094.383-.656.383-1.504 0-2.187-.41-.656-1.12-1.094-1.886-1.094-.793 0-1.504.438-1.915 1.094-.382.683-.382 1.531 0 2.187A2.22 2.22 0 0 0 7.188 13.5m3.253 0h3.09c-.437-.602-.656-1.367-.656-2.187 0-2.16 1.75-3.938 3.938-3.938 2.16 0 3.937 1.777 3.937 3.938a3.94 3.94 0 0 1-3.937 3.937H7.188a3.92 3.92 0 0 1-3.938-3.937c0-2.16 1.75-3.938 3.938-3.938 2.16 0 3.937 1.777 3.937 3.938 0 .82-.246 1.585-.684 2.187m6.371-4.375c-.793 0-1.503.438-1.914 1.094-.382.683-.382 1.531 0 2.187a2.22 2.22 0 0 0 1.915 1.094c.765 0 1.476-.41 1.886-1.094.383-.656.383-1.504 0-2.187-.41-.656-1.12-1.094-1.887-1.094"
    }, null, -1)
  ]))]))
}
export default { render: render }